import { useTranslation } from 'react-i18next'

import { useAccountSettingsServiceGetAccountSettingsEndpoint } from 'src/api/queries'

import {
  AT_LEAST_ONE_NUMBER_REGEX,
  CAPITAL_LETTER_REGEX,
  SMALL_LETTERS_REGEX,
  SPECIAL_CHARACTERS_REGEX
} from '../constants'

export const usePasswordValidationRules = () => {
  const { t } = useTranslation()
  const { data } = useAccountSettingsServiceGetAccountSettingsEndpoint()

  const {
    minLength,
    maxLength,
    requireDigit,
    requireLowerCase,
    requireSpecialCharacters,
    requireUpperCase
  } = data?.passwordValidationRules ?? {}

  const regexArray = [
    {
      condition: minLength !== null || maxLength !== null,
      regex: new RegExp(`^.{${minLength},${maxLength}}$`),
      text: `${t('auth.passwordRegex.password')} ${minLength}-${maxLength} ${t('auth.passwordRegex.characters')}`
    },
    {
      condition: requireDigit,
      regex: AT_LEAST_ONE_NUMBER_REGEX,
      text: `${t('auth.passwordRegex.number')}`
    },
    {
      condition: requireLowerCase,
      regex: SMALL_LETTERS_REGEX,
      text: `${t('auth.passwordRegex.lowercase')}`
    },
    {
      condition: requireSpecialCharacters,
      regex: SPECIAL_CHARACTERS_REGEX,
      text: `${t('auth.passwordRegex.special')}`
    },
    {
      condition: requireUpperCase,
      regex: CAPITAL_LETTER_REGEX,
      text: `${t('auth.passwordRegex.uppercase')}`
    }
  ].filter((item) => item.condition)

  return {
    regexArray
  }
}
